import { createIcon } from '@chakra-ui/icons';

export const UserCircleFrame = createIcon({
  displayName: 'UserCircleFrame',
  viewBox: '0 0 15 14',
  path: [
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3005_11236)">
        <path
          d="M7.5 0C3.65 0 0.5 3.15 0.5 7C0.5 10.85 3.65 14 7.5 14C11.35 14 14.5 10.85 14.5 7C14.5 3.15 11.35 0 7.5 0ZM4.4375 11.2875C4.4375 10.5 5.8375 10.0625 5.8375 10.0625C6.3625 10.325 6.8875 10.5 7.5 10.5C8.1125 10.5 8.6375 10.325 9.1625 10.0625C9.1625 10.0625 10.5625 10.5875 10.5625 11.2875C9.6875 11.9 8.6375 12.25 7.5 12.25C6.3625 12.25 5.3125 11.9 4.4375 11.2875ZM9.25 7C9.25 7.9625 8.4625 8.75 7.5 8.75C6.5375 8.75 5.75 7.9625 5.75 7V6.125C5.75 5.1625 6.5375 4.375 7.5 4.375C8.4625 4.375 9.25 5.1625 9.25 6.125V7ZM11.875 9.975C11.35 9.1875 10.475 8.8375 10.475 8.8375C10.825 8.3125 11 7.7 11 7V6.125C11 4.2 9.425 2.625 7.5 2.625C5.575 2.625 4 4.2 4 6.125V7C4 7.7 4.175 8.3125 4.525 8.8375C4.525 8.8375 3.5625 9.1875 3.125 9.975C2.6 9.1 2.25 8.1375 2.25 7C2.25 4.1125 4.6125 1.75 7.5 1.75C10.3875 1.75 12.75 4.1125 12.75 7C12.75 8.05 12.4 9.1 11.875 9.975Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3005_11236">
          <rect width="14" height="14" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
